export default __webpack_public_path__ + "static/media/1821.657c0723.png";